export const staffProject = (state) => state.staff.staff.data
export const isLoading = (state) => state.staff.isLoading
export const isSuccess = (state) => state.staff.isSuccess
export const error = (state) => state.staff.error
export const staffXml = (state) => state.staff.staffXML
export const statusCode = (state) => state.staff.staff.data.statusCode

export const positionByDeptType = (state) => state.staff.positionByDeptType
export const staffExperience = (state) => state.staff.staffExperience
export const staffUnit = (state) => state.staff.staffUnit
export const staffLevel = (state) => state.staff.staffLevel
